export default {
  ticketList: {
    listDesc:
      "تمام تیکت‌هایی که برای واحد پشتیبانی اکسکوینو ارسال کرده اید، در این صفحه لیست شده اند:",
    submitTicket: "ثبت تیکت جدید",
    noMessages: "هیچ پیامی ندارید",
    id: "شناسه",
    department: "بخش",
    subject: "عنوان",
    lastUpdate: "آخرین به روزرسانی",
    status: "وضعیت",
    previousTickets: "مشاهده تیکت های قبلی"
  },
  singleTicket: {
    closed: "بسته شده",
    closeTicket: "بستن تیکت",
    viewMore: "مشاهده بیشتر",
    ticketIsClosed: "این تیکت بسته شده است",
    ticketWasClosed: "تیکت بسته شد",
    submitTicketIfHaveQuestion:
      "در صورتی که سوالی دارید لطفا تیکت جدید ثبت کنید",
    submitTicket: "ثبت تیکت جدید",
    messagePlaceholder: "پیام ...",
    doYouClose:
      "اگر تیکت را ببندید، یعنی به پاسخ سوال‌تان رسیده‌اید و نیازی به پیگیری ندارد.",
    sureClose: "مطمئنم، بستن تیکت",
    giveUp: "انصراف از بستن تیکت",
    notAValidFormat: "فرمت فایل درست نیست.",
    notAValidSize: "سایز فایل باید کمتر از 4MB باشد"
  },
  createTicket: {
    selectSubject:
      "لطفا جهت ارسال درخواست پشتیبانی موضوع مورد نظر را انتخاب نمایید:",
    subject: "موضوع",
    title: "عنوان",
    titleError: "عنوان تیکت را وارد کنید",
    messagePlaceholder: "درباره مشکل خود توضیح دهید...",
    messageError: "توضیحات تیکت را وارد کنید",
    attachmentTitle: "ضمیمه کردن فایل (اختیاری)",
    submit: "ثبت و ارسال",
    hintsTitle: "جهت پاسخگویی بهتر به مسائل زیر توجه کنید:",
    supportNumber: "تلفن پشتیبانی:",
    supportEmail: "ایمیل پشتیبانی:",
    alerts: {
      alertDesc:
        "توجه داشته باشید اکسکوینو هرگز در رابطه با رمزهای عبور شما سوالی نخواهد کرد.اطلاعات خصوصی کیف پول خود را به هیچ فردی ندهید."
    },
    attachment: {
      fileFormats: "فرمت مجاز فایل: jpg, jpeg, png",
      fileFormatIsNotCorrect: "فرمت فایل درست نیست.",
      moreThanMaxSize:
        "حجم فایل ضمیمه شده نباید بیشتر از  {count} مگابایت باشد.",
      lessThanMinSize: "حجم فایل ضمیمه شده نباید کمتر از  {count} مگابایت باشد."
    }
  },
  conversation: {
    excoinoSupport: "پشتیبانی اکسکوینو"
  }
};
